import styled, {css} from "styled-components";
import {InputSProps} from "@FRAMEWORK/ui/types/d";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import SearchIcon from "@FRAMEWORK/ui/desktop/icon/SearchIcon";

interface SearchProps extends InputSProps {
	icon: string;
	isReadonly?: boolean;
	readOnly?: boolean;
}

const InputWrap = styled.div`
	position: relative;
	width: 100%;
`;

const Input = styled.input<{isReadonly?: boolean}>`
	position: relative;
	z-index: 1;
	display: flex;
	width: 100%;
	height: 50px;
	padding: 0 42px 0 10px;
	border: 1px solid var(--line-color);
	background-color: transparent;
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: ${props => (props.isReadonly ? "pointer" : "auto")};
`;

const Icon = styled(SearchIcon)<{icon: string}>`
	position: absolute;
	right: 10px;
	top: 50%;
	z-index: 0;
	margin-left: 0;
	background-image: url(${SpriteImage});
	${props => {
		if (props.icon === "calendar") {
			return css`
				width: 18px;
				height: 20px;
				background-position: -20px 0;
			`;
		}
	}}
	transform: translateY(-50%);
`;

const SearchInput = ({icon, ...props}: SearchProps) => (
	<InputWrap>
		<Input type="text" {...props} />
		<Icon icon={icon} />
	</InputWrap>
);

export default SearchInput;
